import React from 'react';
import { observer } from 'mobx-react';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './checkbox_input.module.css';
import {
  CheckboxInput as BaseCheckboxInput,
  CheckboxInputProps as BaseCheckboxInputProps,
} from 'ui/base/input';

type CheckboxInputStyles = {
  unselected: string;
  selected: string;
  checkbox: string;
};

const themedStyles: ThemedStyles<CheckboxInputStyles> = {
  [Theme.DAYLIGHT]: {
    unselected: baseStyles.daylightUnselectedLabel,
    selected: baseStyles.daylightSelectedLabel,
    checkbox: baseStyles.checkbox,
  },
  [Theme.MIDNIGHT]: {
    unselected: baseStyles.midnightUnselectedLabel,
    selected: baseStyles.midnightSelectedLabel,
    checkbox: baseStyles.checkbox,
  },
};

export type CheckboxInputProps = Omit<BaseCheckboxInputProps, 'className'>;
export const CheckboxInput = observer(({ store, ...props }: CheckboxInputProps) => {
  const styles = useStyles(themedStyles);
  return (
    <label className={store.value ? styles.selected : styles.unselected}>
      <BaseCheckboxInput className={styles.checkbox} store={store} {...props}/>
    </label>
  );
});
